// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import UserRules from './pages/rules/rules';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';

import ThemeUpdate from './admin/pages/themeUpdate/themeUpdate';
import PhotoboothUpload  from './pages/photobooth/PhotoboothUpload';
import PhotoboothAvatars from './pages/photobooth/PhotoboothAvatars';
import PhotoboothFinal   from './pages/photobooth/PhotoboothFinal';
import Avatar             from './pages/avatar/Avatar';



function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const { pathname } = location;
    if (pathname.startsWith("/admin")) {
      body.classList.remove("common-bg");
      body.classList.remove("game-bg");
    } else if (pathname.startsWith("/game")) {
      body.classList.remove("common-bg");
      body.classList.add("game-bg");
    } else {
      body.classList.remove("game-bg");
      body.classList.add("common-bg");
    }
  }, [location]);
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="themeUpdate" element={<Admin><ThemeUpdate /></Admin>} />
          
        
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules/>} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/avatar"             element={<Avatar />} />
              <Route path="/photobooth"         element={<PhotoboothUpload />} />
              <Route path="/photobooth/avatars" element={<PhotoboothAvatars />} />
              <Route path="/photobooth/final"   element={<PhotoboothFinal />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
